import { useSearchCustomerAPI } from "@/app/hooks/api_hooks/customer_profile/useSearchCustomerAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useAfterFirstRender } from "@/app/hooks/useAfterFirstRender";
import { useRegexEngine } from "@/app/hooks/useRegexEngine";
import { useRouter } from "@/app/hooks/useRouter";
import Mic from "@assets/images/mic.png";
import MicGif from "@assets/images/mic_gif.gif";
import { useNavigate } from "react-router";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
const SpeechRecognitionMic = () => {
  const { getRouteKey } = useRouter();
  const { transcript, listening, browserSupportsSpeechRecognition } = useSpeechRecognition();
  const { extractTenDigitNumber } = useRegexEngine();
  const { execute: searchCustomer } = useSearchCustomerAPI();
  const navigate = useNavigate();
  const { setInvisible } = useModalActions("SPEECH_RECOGNITION_MODAL");
  const handleStartListening = () => {
    SpeechRecognition.startListening({ continuous: false });
  };

  const handleStopListening = () => {
    SpeechRecognition.stopListening();
  };

  const handleSearchCustomer = async (mobile: string) => {
    const results = await searchCustomer(mobile, "0").then((searchResults) => {
      return searchResults;
    });
    if (results) {
      setInvisible();
      navigate(getRouteKey("SEARCH_CUSTOMER", "url"));
    }
  };

  useAfterFirstRender(() => {
    if (!listening && transcript.length > 3) {
      const matchedStrings = extractTenDigitNumber(transcript);
      if (matchedStrings.length > 0) {
        const probableMobile = matchedStrings
          ?.join("")
          ?.split("")
          ?.filter((f) => f !== " ")
          ?.splice(0, 10)
          ?.join("");

        if (probableMobile.length === 10) {
          handleSearchCustomer(probableMobile);
        }
      }
    }
  }, [listening, transcript]);

  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }

  return (
    <div className="w-full h-full flex justify-center items-center flex-col">
      <div>
        {listening ? (
          <img src={MicGif} className="cursor-pointer" onClick={handleStopListening} />
        ) : (
          <img src={Mic} className="cursor-pointer" alt="Voice assistant Mic" onClick={handleStartListening} />
        )}
      </div>
      {!listening && (
        <div>
          <p>Hi 👋, I am vetic assistant here to help you. </p>
          <p>
            <span className="text-gray-500 text-[10px]">e.g 'Can you search for customer with 9865612435'</span>
          </p>
        </div>
      )}
      <p className="text-gray-400 text-[12px] w-10/12 shadow-md px-2 py-2 rounded-md ">
        <span className="text-gray-600">Query</span>
        <span className="ml-2">"{transcript}"</span>
      </p>
    </div>
  );
};
export default SpeechRecognitionMic;
